export default [
  {
    paletteName : 'Material UI Colors',
    id          : 'material-ui-colors',
    emoji       : '🎨',
    colors      : [
      { name: 'red', color: '#F44336' },
      { name: 'pink', color: '#E91E63' },
      { name: 'purple', color: '#9C27B0' },
      { name: 'deep purple', color: '#673AB7' },
      { name: 'indigo', color: '#3F51B5' },
      { name: 'blue', color: '#2196F3' },
      { name: 'light blue', color: '#03A9F4' },
      { name: 'cyan', color: '#00BCD4' },
      { name: 'teal', color: '#009688' },
      { name: 'green', color: '#4CAF50' },
      { name: 'light green', color: '#8BC34A' },
      { name: 'lime', color: '#CDDC39' },
      { name: 'yellow', color: '#FFEB3B' },
      { name: 'amber', color: '#FFC107' },
      { name: 'orange', color: '#FF9800' },
      { name: 'deep orange', color: '#FF5722' },
      { name: 'brown', color: '#795548' },
      { name: 'grey', color: '#9E9E9E' },
      { name: 'blue grey', color: '#607D8B' },
    ],
  },
  {
    paletteName : 'Flat UI Colors v1',
    id          : 'flat-ui-colors-v1',
    emoji       : '🤙',
    colors      : [
      { name: 'Turquoise', color: '#1abc9c' },
      { name: 'Emerald', color: '#2ecc71' },
      { name: 'Peter River', color: '#3498db' },
      { name: 'Amethyst', color: '#9b59b6' },
      { name: 'Wet Asphalt', color: '#34495e' },
      { name: 'Green Sea', color: '#16a085' },
      { name: 'Nephritis', color: '#27ae60' },
      { name: 'Belize Hole', color: '#2980b9' },
      { name: 'Wisteria', color: '#8e44ad' },
      { name: 'Midnight Blue', color: '#2c3e50' },
      { name: 'Sunflower', color: '#f1c40f' },
      { name: 'Carrot', color: '#e67e22' },
      { name: 'Alizarin', color: '#e74c3c' },
      { name: 'Clouds', color: '#ecf0f1' },
      { name: 'Concrete', color: '#95a5a6' },
      { name: 'Orange', color: '#f39c12' },
      { name: 'Pumpkin', color: '#d35400' },
      { name: 'Pomegranate', color: '#c0392b' },
      { name: 'Silver', color: '#bdc3c7' },
      { name: 'Asbestos', color: '#7f8c8d' },
    ],
  },
  {
    paletteName : 'Flat UI Colors Dutch',
    id          : 'flat-ui-colors-dutch',
    emoji       : '🇳🇱',
    colors      : [
      { name: 'Sunflower', color: '#FFC312' },
      { name: 'Energos', color: '#C4E538' },
      { name: 'Blue Martina', color: '#12CBC4' },
      { name: 'Lavender Rose', color: '#FDA7DF' },
      { name: 'Bara Rose', color: '#ED4C67' },
      { name: 'Radiant Yellow', color: '#F79F1F' },
      { name: 'Android Green', color: '#A3CB38' },
      { name: 'Mediterranean Sea', color: '#1289A7' },
      { name: 'Lavender Tea', color: '#D980FA' },
      { name: 'Verry Berry', color: '#B53471' },
      { name: 'Puffins Bill', color: '#EE5A24' },
      { name: 'Pixelated Grass', color: '#009432' },
      { name: 'Merchant Marine Blue', color: '#0652DD' },
      { name: 'Forgotten Purple', color: '#9980FA' },
      { name: 'Hollyhock', color: '#833471' },
      { name: 'Red Pigment', color: '#EA2027' },
      { name: 'Turkish Aqua', color: '#006266' },
      { name: '20000 Leagues Under The Sea', color: '#1B1464' },
      { name: 'Circumorbital Ring', color: '#5758BB' },
      { name: 'Magenta Purple', color: '#6F1E51' },
    ],
  },
  {
    paletteName : 'Flat UI Colors American',
    id          : 'flat-ui-colors-american',
    emoji       : '🇺🇸',
    colors      : [
      { name: 'Light Greenish Blue', color: '#55efc4' },
      { name: 'Faded Poster', color: '#81ecec' },
      { name: 'Green Darner Tail', color: '#74b9ff' },
      { name: 'Shy Moment', color: '#a29bfe' },
      { name: 'City Lights', color: '#dfe6e9' },
      { name: 'Mint Leaf', color: '#00b894' },
      { name: 'Robins Egg Blue', color: '#00cec9' },
      { name: 'Electron Blue', color: '#0984e3' },
      { name: 'Exodus Fruit', color: '#6c5ce7' },
      { name: 'Soothing Breeze', color: '#b2bec3' },
      { name: 'Sour Lemon', color: '#ffeaa7' },
      { name: 'First Date', color: '#fab1a0' },
      { name: 'Pink Glamour', color: '#ff7675' },
      { name: 'Pico 8 Pink', color: '#fd79a8' },
      { name: 'American River', color: '#636e72' },
      { name: 'Bright Yarrow', color: '#fdcb6e' },
      { name: 'Orange Ville', color: '#e17055' },
      { name: 'Chi-Gong', color: '#d63031' },
      { name: 'Prunus Avium', color: '#e84393' },
      { name: 'Dracula Orchid', color: '#2d3436' },
    ],
  },
  {
    paletteName : 'Flat UI Colors Aussie',
    id          : 'flat-ui-colors-aussie',
    emoji       : '🇦🇺',
    colors      : [
      { name: 'Beekeeper', color: '#f6e58d' },
      { name: 'Spiced Nectarine', color: '#ffbe76' },
      { name: 'Pink Glamour', color: '#ff7979' },
      { name: 'June Bud', color: '#badc58' },
      { name: 'Coastal Breeze', color: '#dff9fb' },
      { name: 'Turbo', color: '#f9ca24' },
      { name: 'Quince Jelly', color: '#f0932b' },
      { name: 'Carmine Pink', color: '#eb4d4b' },
      { name: 'Pure Apple', color: '#6ab04c' },
      { name: 'Hint Of Ice Pack', color: '#c7ecee' },
      { name: 'Middle Blue', color: '#7ed6df' },
      { name: 'Heliotrope', color: '#e056fd' },
      { name: 'Exodus Fruit', color: '#686de0' },
      { name: 'Deep Koamaru', color: '#30336b' },
      { name: 'Soaring Eagle', color: '#95afc0' },
      { name: 'Greenland Green', color: '#22a6b3' },
      { name: 'Steel Pink', color: '#be2edd' },
      { name: 'Blurple', color: '#4834d4' },
      { name: 'Deep Cove', color: '#130f40' },
      { name: 'Wizard Grey', color: '#535c68' },
    ],
  },
  {
    paletteName : 'Flat UI Colors British',
    id          : 'flat-ui-colors-british',
    emoji       : '🇬🇧',
    colors      : [
      { name: 'Protoss Pylon', color: '#00a8ff' },
      { name: 'Periwinkle', color: '#9c88ff' },
      { name: 'Rise-N-Shine', color: '#fbc531' },
      { name: 'Download Progress', color: '#4cd137' },
      { name: 'Seabrook', color: '#487eb0' },
      { name: 'Vana Dyl Blue', color: '#0097e6' },
      { name: 'Matt Purple', color: '#8c7ae6' },
      { name: 'Nanohanacha Gold', color: '#e1b12c' },
      { name: 'Skirret Green', color: '#44bd32' },
      { name: 'Naval', color: '#40739e' },
      { name: 'Nasturcian Flower', color: '#e84118' },
      { name: 'Lynx White', color: '#f5f6fa' },
      { name: 'Blueberry Soda', color: '#7f8fa6' },
      { name: 'Mazarine Blue', color: '#273c75' },
      { name: 'Blue Nights', color: '#353b48' },
      { name: 'Harley Orange', color: '#c23616' },
      { name: 'Hint Of Pensive', color: '#dcdde1' },
      { name: 'Chain Gang Grey', color: '#718093' },
      { name: 'Pico Void', color: '#192a56' },
      { name: 'Electro Magnetic', color: '#2f3640' },
    ],
  },
  {
    paletteName : 'Flat UI Colors Spanish',
    id          : 'flat-ui-colors-spanish',
    emoji       : '🇪🇸',
    colors      : [
      { name: 'Jacksons Purple', color: '#40407a' },
      { name: 'C64 Purple', color: '#706fd3' },
      { name: 'Swan White', color: '#f7f1e3' },
      { name: 'Summer Sky', color: '#34ace0' },
      { name: 'Celestial Green', color: '#33d9b2' },
      { name: 'Lucky Point', color: '#2c2c54' },
      { name: 'Liberty', color: '#474787' },
      { name: 'Hot Stone', color: '#aaa69d' },
      { name: 'Devil Blue', color: '#227093' },
      { name: 'Palm Springs Splash', color: '#218c74' },
      { name: 'Flourescent Red', color: '#ff5252' },
      { name: 'Synthetic Pumpkin', color: '#ff793f' },
      { name: 'Crocodile Tooth', color: '#d1ccc0' },
      { name: 'Mandarin Sorbet', color: '#ffb142' },
      { name: 'Spiced Butter Nut', color: '#ffda79' },
      { name: 'Eye Of Newt', color: '#b33939' },
      { name: 'Chilean Fire', color: '#cd6133' },
      { name: 'Grey Porcelain', color: '#84817a' },
      { name: 'Alameda Ochre', color: '#cc8e35' },
      { name: 'Desert', color: '#ccae62' },
    ],
  },
  {
    paletteName : 'Flat UI Colors Indian',
    id          : 'flat-ui-colors-indian',
    emoji       : '🇮🇳',
    colors      : [
      { name: 'Orchid Orange', color: '#FEA47F' },
      { name: 'Spiro Disco Ball', color: '#25CCF7' },
      { name: 'Honey Glow', color: '#EAB543' },
      { name: 'Sweet Garden', color: '#55E6C1' },
      { name: 'Falling Star', color: '#CAD3C8' },
      { name: 'Rich Gardenia', color: '#F97F51' },
      { name: 'Clear Chill', color: '#1B9CFC' },
      { name: 'White Pepper', color: '#F8EFBA' },
      { name: 'Keppel', color: '#58B19F' },
      { name: 'Ships Officer', color: '#2C3A47' },
      { name: 'Fiery Fuchsia', color: '#B33771' },
      { name: 'Blue Bell', color: '#3B3B98' },
      { name: 'Georgia Peach', color: '#FD7272' },
      { name: 'Oasis Stream', color: '#9AECDB' },
      { name: 'Bright Ube', color: '#D6A2E8' },
      { name: 'Magenta Purple', color: '#6D214F' },
      { name: 'Ending Navy Blue', color: '#182C61' },
      { name: 'Sasquatch Socks', color: '#FC427B' },
      { name: 'Pine Glade', color: '#BDC581' },
      { name: 'Highlighter Lavender', color: '#82589F' },
    ],
  },
  {
    paletteName : 'Flat UI Colors French',
    id          : 'flat-ui-colors-french',
    emoji       : '🇫🇷',
    colors      : [
      { name: 'Flat Flesh', color: '#fad390' },
      { name: 'Melon Melody', color: '#f8c291' },
      { name: 'Livid', color: '#6a89cc' },
      { name: 'Spray', color: '#82ccdd' },
      { name: 'Paradise Green', color: '#b8e994' },
      { name: 'Squash Blossom', color: '#f6b93b' },
      { name: 'Mandarin Red', color: '#e55039' },
      { name: 'Azraq Blue', color: '#4a69bd' },
      { name: 'Dupain', color: '#60a3bc' },
      { name: 'Aurora Green', color: '#78e08f' },
      { name: 'Iceland Poppy', color: '#fa983a' },
      { name: 'Tomato Red', color: '#eb2f06' },
      { name: 'Yue Guang Blue', color: '#1e3799' },
      { name: 'Good Samaritan', color: '#3c6382' },
      { name: 'Waterfall', color: '#38ada9' },
      { name: 'Carrot Orange', color: '#e58e26' },
      { name: 'Jalapeno Red', color: '#b71540' },
      { name: 'Dark Sapphire', color: '#0c2461' },
      { name: 'Forest Blues', color: '#0a3d62' },
      { name: 'Reef Encounter', color: '#079992' },
    ],
  },
];
